<template>

  <div class="content">
    <div class="container-fluid">
      <card>
        <b-alert show variant="danger" dismissible v-if="errors.length">
          <h4 class="alert-heading my-0 text-center"><i class="fas fa-exclamation-triangle"></i> Hata</h4>
          <ul class="mb-0">
            <li v-for="e in errors">
              {{e}}
            </li>
          </ul>
        </b-alert>


        <div class="row">
          <div class="col-12 input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text border-0 bg-white" for="inputGroupSelect01">Kullanıcı Türü</label>
            </div>
            <select v-model="user.user_type_id" v-bind:class="{'is-invalid' : errors.includes('Kategori')}" class="custom-select">
              <option v-for="type in userTypes" v-bind:value="type.id">
                {{ type.name }}
              </option>
            </select>
          </div>
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">Ad</span>
            </div>
            <input type="text" class="form-control" placeholder="Ad"  v-bind:class="{'is-invalid' : errors.includes('Başlık')}" v-model="user.name" id="name" aria-describedby="basic-addon1">
          </div>
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">Soyad</span>
            </div>
            <input type="text" class="form-control" placeholder="Soyad" v-bind:class="{'is-invalid' : errors.includes('Başlık')}" v-model="user.surname" id="surname" aria-describedby="basic-addon1">
          </div>
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">TC Kimlik No</span>
            </div>
            <input type="number" class="form-control" placeholder="TC Kimlik Numarası" v-bind:class="{'is-invalid' : errors.includes('Başlık')}" v-model="user.tcno" id="tcno" aria-describedby="basic-addon1">
          </div>
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">E-Posta</span>
            </div>
            <input type="text" class="form-control" placeholder="E-Posta" v-bind:class="{'is-invalid' : errors.includes('Başlık')}" v-model="user.email" id="email" aria-describedby="basic-addon1">
          </div>
          <div class="col-12">
            <h6>Şifre Değiştir</h6>
          </div>
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">Şifre</span>
            </div>
            <input type="password" class="form-control" placeholder="Şifre" v-bind:class="{'is-invalid' : errors.includes('Başlık')}" v-model="user.password" id="pass" aria-describedby="basic-addon1">
          </div>
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">Şifre Tekrar</span>
            </div>
            <input type="password" class="form-control" placeholder="Şifre Tekrar" v-bind:class="{'is-invalid' : errors.includes('Başlık')}" v-model="passwordRepeat" id="passw" aria-describedby="basic-addon1">
          </div>
          <!-- <div class="col-12 col-md-11">
            <vue-tabs>
              <v-tab class="card border-top-0" title="Profil Fotoğrafı">
                <div class="row">
                  <div class="col-12 col-md-12 m-3">
                    <p class="text-warning"><small><i class="fas fa-exclamation-triangle"></i> Profil fotoğrafını koymak zorunlu değil. Ama oluşturacağınız kullanıcı türü Köşe Yazarı ise, web sitede görüneceği için koymanız önemli!</small></p>
                    <b-btn v-b-modal.croppieModal v-on:click="initiateCroppie('main')" v-bind:class="{'is-invalid' : errors.includes('image')}">Fotoğraf Seç</b-btn>
                    <img v-bind:src="image.cropped" class="img-fluid mt-4 d-block border border-secondary p-2" v-bind:class="{'border-danger' : errors.includes('Resim')}">
                  </div>
                </div>
              </v-tab>
            </vue-tabs>
          </div> -->

          <div class="col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start">
            <button class="btn btn-primary btn-fill" v-on:click="checkForm">Kaydet</button>
          </div>
        </div>
        <b-modal id="croppieModal" hide-footer size="lg" title="Resim Seç">
          <input name="myFile" id="myImage" class="m-3" type="file" @change="bind()">
          <vue-croppie :enable-resize="false" :viewport="{width: 300, height: 300, type: 'suare'}" :boundary="{width: 400, height: 400}" ref=main :enableOrientation="true" @result="result">
          </vue-croppie>
          <b-btn class="mt-3" variant="danger btn-fill" @click="hideCroppieModal()">İptal</b-btn>
          <b-btn class="mt-3" variant="success btn-fill float-right" @click="crop()">Kaydet</b-btn>
        </b-modal>
      </card>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
  export default {
    data: function () {
      return {
        isEdit:false,
        user:{
          user_type_id: null,
          name: null,
          surname: null,
          tcno: null,
          email: null,
          password: null,
          profile_photo: null,
          url: 'nourl',
          authkey: 'nokey',
          recoverytoken: null,
          lastrecovery: null,
          is_active: 1
        },
        passwordRepeat:null,
        userTypes:null,
        errors:[],
        image:{
          cropped: null
        },
        imageRecreated: false,
        croppieType : 'main',
        // end of post data
        options: {
          language_url: '/static/plugins/tinymce-lang/tr.js',
          height: 300
        }
      }
    },
    components: {
      Checkbox,
      Card
    },
    methods: {
      checkForm:function() {
        this.errors = [];
        if(!this.user.name) {this.errors.push("Ad Alanı Boş")};
        if(!this.user.surname) {this.errors.push("Soyad Alanı Boş")};
        if(!this.user.email) {this.errors.push("E-Posta Alanı Boş")};
        if(!this.isEdit){
          if(!this.user.password) {this.errors.push("Şifre Alanı Boş")};
        }
        if(!this.isEdit){
          if(this.user.password !== this.passwordRepeat) {
            this.errors.push("Şifreler Birbiriyle Eşleşmedi")
          }
        }else{
          if((this.user.password !== this.passwordRepeat) && (('password' in this.user) && this.user.password !== "")) {
            this.errors.push("Şifreler Birbiriyle Eşleşmedi")
          }
        }
        if(!this.validEmail(this.user.email)) {this.errors.push("E-Posta Formatı Doğru Değil")}
          if(!this.errors.length) {
            this.saveImage()
          }
        },
        validEmail:function(email) {
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        },
        saveImage: function () {
          this.toggleLoader()
          if(this.imageRecreated){
            this.$http.post('/api/images/upload/' + this.user.url, this.image).then(
              response => {
                this.user.profile_photo = response.body.Data.Response.name
                if(this.isEdit){
                  this.updateUser()
                }else{
                  this.saveUser()
                }
              },
              e => {
                button.innerHTML = 'Kaydet'
                this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
                this.toggleLoader()
              })
          }else{
            if(this.isEdit){
              this.updateUser()
            }else{
              this.saveUser()
            }
          }

        },
        saveUser: function() {
          this.$http.post('/api/users/add', this.user).then(
            response => {
              this.notifier('top', 'right', 'success', 'Başarılı')
              if(this.$route.params.type === 'member'){
                this.$router.push('/members')
              }else{
                this.$router.push('/users')
              }
              this.toggleLoader()
            },
            e => {
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
              this.toggleLoader()
            })
        },
        updateUser: function() {
          if(this.user.password=== ""){
            delete this.user.password
          }
          this.user.url = this.user.url + '-' + this.user.id
          this.$http.post('/api/users/edit/' + this.user.id, this.user).then(
            response => {
              this.notifier('top', 'right', 'success', 'Başarılı')
              if(this.$route.params.type === 'member'){
                this.$router.push('/members')
              }else{
                this.$router.push('/users')
              }
              this.toggleLoader()
            },
            e => {
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
              this.toggleLoader()
            })
        },
        initiateCroppie(type){
          this.croppieType = type
        },
        bind() {
          var oFReader = new FileReader();
          if(document.getElementById("myImage").files.length){
            oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
            var refz = this.$refs
            oFReader.onload = function (oFREvent) {
              refz.main.bind({
                url: oFREvent.target.result
              })
            };   
          }

        },
        crop () {
          var dis = this;
          return new Promise(resolve => {
            let options = {
              format: 'jpeg',
              size: {
                width: 800,
                height: 800
              },
              quality: 1
            };
            dis.$refs.main.result(options, (output) => {
              if(this.croppieType === 'main'){
                dis.image.cropped = output
                dis.imageRecreated = true
              }else if(this.croppieType === 'slider'){
                dis.sliderimage.cropped = output
                dis.sliderImageLoaded = true
              }
              this.hideCroppieModal()
              dis.$refs.main.refresh()
              resolve(output)
            })
          })
        },
        hideCroppieModal(){
          this.$root.$emit('bv::hide::modal','croppieModal')
        },
        result(output) {
          return output
        }
      },
      mounted: function () {
        this.$nextTick(function () {
          this.toggleLoader()
          this.$http.get('/api/user-types/all').then(
            response => {
              this.userTypes = response.body
              if(this.$route.params.id){
                this.$http.get('/api/users/get-without-joins/' + this.$route.params.id).then(response => {
                  this.isEdit = true
                  this.user = response.body
                  this.image.cropped = this.mediaURL() + this.user.profile_photo
                  this.toggleLoader()
                }, response => {
                  this.notifier(
                    'top',
                    'right',
                    'danger',
                    'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
                    )
                  this.toggleLoader()
                })
              }else{
                this.toggleLoader()
              }
            },
            er => {
              this.toggleLoader()
              this.notifier(
                'top',
                'right',
                'danger',
                'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
                )
            }
            )
        })
      }
    }
  </script>
  <style>
  .input-group-text.is-valid{
    border-color: #28a745 !important;
  }
  .input-group-text{
    transition: 300ms;
  }
  .input-group-text.is-invalid{
    border-color: #dc3545 !important;
    background-color: #dc3545;
    color:#fff;
  }
  .form-check-label{
    font-size: 16px !important;
    line-height: 15px !important;
    text-transform: capitalize !important;
  }
  .seo-text{
    background-color: #e9ecef;
    border: 1px solid #ced4da; 
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UserModules/AddEdit.vue